<template>
  <div>
    <div class="content-wizard"
         :class="[{'sk-loading': initLoading || uploadLoading}, {'ibox-content': !initLoading}]"
         style="border-width: 0;">
      <div v-if="initLoading || uploadLoading"
           class="sk-spinner sk-spinner-double-bounce">
        <div class="sk-double-bounce1"></div>
        <div class="sk-double-bounce2"></div>
      </div>
      <div v-if="!initLoading"
           class="row">
        <div class="col-lg-12">
          <div class="row">
            <documents-block v-if="owner && owner.lastName"
                             title="Documents du titulaire du certificat d'immatriculation"
                             type="owner"
                             :user="owner"
                             :ownerInformation="ownerInformation"
                             :command="command"
                             :user-documents="ownerDocuments"/>

            <documents-block v-if="futureOwner && futureOwner.lastName"
                            title="Documents du futur propriétaire"
                            type="futureOwner"
                            :user="futureOwner"
                            :futureOwner="ownerInformation"
                            :command="command"
                            :user-documents="futureOwnerDocuments"/>

            <documents-block v-if="coOwner"
                             title="Documents du cotitulaire du certificat d'immatriculation"
                             type="coOwner"
                             :user="coOwner"
                             :ownerInformation="ownerInformation"
                             :command="command"
                             :user-documents="coOwnerDocuments"/>

            <h3 v-if="!owner && !futureOwner" class="font-bold">Veuillez renseigner les informations dans l'onglet "Identité".</h3>
          </div>
          <div class="m-t-sm">
            <small><i class="fa fa-warning"></i> La procuration est obligatoire si le propriétaire ne peut pas être présent au rendez-vous de cession</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <button type="button"
                class="pull-left btn btn-w-m btn-primary"
                @click="$parent.toggleBlock(isCurrentOwner ? 2 : 1)">Précédent</button>
      </div>
    </div>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import DocumentsBlock from './DocumentsBlock'

  export default {
    props: {
      isCurrentOwner: {
        type: Boolean,
        required: false,
        default: true
      },
      command: {
        type: Object,
        required: true
      }
    },

    components: {
      DocumentsBlock
    },

    data: () => ({
      ownerInformation: null,
      ownerDocuments: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "owner",
          page: "owner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "owner",
          page: "owner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "owner",
          info: "proc",
          page: "owner"
        }
      ],
      coOwnerDocuments: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "coOwner",
          page: "owner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "coOwner",
          page: "owner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "coOwner",
          info: "proc",
          page: "owner"
        }
      ],
      futureOwnerDocuments: [
        {
          id: "",
          title: "Identité recto",
          code: "idCardRecto",
          valid: false,
          user: "futureOwner",
          page: "owner"
        },
        {
          id: "",
          title: "Identité verso",
          code: "idCardVerso",
          valid: false,
          user: "futureOwner",
          page: "owner"
        },
        {
          id: "",
          title: "Procuration",
          code: "procuration",
          valid: false,
          user: "futureOwner",
          info: "proc",
          page: "owner"
        }
      ],
      initLoading: true,
      uploadLoading: false
    }),

    computed: {
      owner () {
        if (!this.isCurrentOwner || !this.ownerInformation) {
          return null
        }
        return this.ownerInformation.owners.owner
      },

      coOwner () {
        if (!this.isCurrentOwner || !this.ownerInformation ||  !this.ownerInformation.owners || !this.ownerInformation.owners.hasCoOwner) {
          return null
        }
        return this.ownerInformation.owners.coOwner
      },

      futureOwner () {
        if (this.isCurrentOwner || !this.ownerInformation) {
          return null
        }
        return this.ownerInformation.owner
      },
    },

    watch: {
      owner () {
        if (this.owner) {
          this.getDocumentsOwner()
        }
      },
      futureOwner () {
        if (this.futureOwner) {
          this.getDocumentsFutureOwner()
        }
      },
    },

    mounted () {

    },

    methods: {
      async getDocumentsOwner () {
        try {
          if (this.isCurrentOwner && this.owner) {
            const resultOwner = await this.$apollo.query({
              query: gql`
                query {
                customerDocument(documentId: "${this.owner.documentId}") {
                  idCardRecto {
                    id,
                    valid
                  }
                  idCardVerso {
                    id,
                    valid
                  }
                  procuration {
                    id,
                    valid
                  }
                }
                }`,
              fetchPolicy: 'no-cache'
            })

            // Owner
            if(resultOwner.data.customerDocument[0].idCardRecto != null && resultOwner.data.customerDocument[0].idCardRecto.id){
                this.ownerDocuments[0].id = resultOwner.data.customerDocument[0].idCardRecto.id
                this.ownerDocuments[0].valid = resultOwner.data.customerDocument[0].idCardRecto.valid
            }
            if(resultOwner.data.customerDocument[0].idCardVerso != null && resultOwner.data.customerDocument[0].idCardVerso.id){
                this.ownerDocuments[1].id = resultOwner.data.customerDocument[0].idCardVerso.id
                this.ownerDocuments[1].valid = resultOwner.data.customerDocument[0].idCardVerso.valid
            }
            if(resultOwner.data.customerDocument[0].procuration != null && resultOwner.data.customerDocument[0].procuration.id){
                this.ownerDocuments[2].id = resultOwner.data.customerDocument[0].procuration.id
                this.ownerDocuments[2].valid = resultOwner.data.customerDocument[0].procuration.valid
            }
          }

          if (this.isCurrentOwner && this.coOwner) {
            const resultCoOwner = await this.$apollo.query({
              query: gql`
                query {
                 customerDocument(documentId: "${this.coOwner.documentId}") {
                   idCardRecto {
                     id,
                     valid
                   }
                   idCardVerso {
                     id,
                     valid
                   }
                   procuration {
                     id,
                     valid
                   }
                 }
                }`,
              fetchPolicy: 'no-cache'
            })

            // CoOwner
            if(resultCoOwner.data.customerDocument[0].idCardRecto != null && resultCoOwner.data.customerDocument[0].idCardRecto.id){
              this.coOwnerDocuments[0].id = resultCoOwner.data.customerDocument[0].idCardRecto.id
              this.coOwnerDocuments[0].valid = resultCoOwner.data.customerDocument[0].idCardRecto.valid
            }
            if(resultCoOwner.data.customerDocument[0].idCardVerso != null && resultCoOwner.data.customerDocument[0].idCardVerso.id){
                this.coOwnerDocuments[1].id = resultCoOwner.data.customerDocument[0].idCardVerso.id
                this.coOwnerDocuments[1].valid = resultCoOwner.data.customerDocument[0].idCardVerso.valid
            }
            if(resultCoOwner.data.customerDocument[0].procuration != null && resultCoOwner.data.customerDocument[0].procuration.id){
                this.coOwnerDocuments[2].id = resultCoOwner.data.customerDocument[0].procuration.id
                this.coOwnerDocuments[2].valid = resultCoOwner.data.customerDocument[0].procuration.valid
            }
          }

          this.initLoading = false

        } catch (e) {
          this.initLoading = false
          this.showBanner('danger', 'Une erreur est survenue lors de la récupération des documents.')
        }
      },
      async getDocumentsFutureOwner () {
        try {
          if (!this.isCurrentOwner && this.futureOwner) {
            const resultFutureOwner = await this.$apollo.query({
              query: gql`
                query {
                customerDocument(documentId: "${this.futureOwner.documentId}") {
                  idCardRecto {
                    id,
                    valid
                  }
                  idCardVerso {
                    id,
                    valid
                  }
                  procuration {
                    id,
                    valid
                  }
                }
                }`,
              fetchPolicy: 'no-cache'
            })

            // Future Owner
            if(resultFutureOwner.data.customerDocument[0].idCardRecto != null && resultFutureOwner.data.customerDocument[0].idCardRecto.id){
                this.futureOwnerDocuments[0].id = resultFutureOwner.data.customerDocument[0].idCardRecto.id
                this.futureOwnerDocuments[0].valid = resultFutureOwner.data.customerDocument[0].idCardRecto.valid
            }
            if(resultFutureOwner.data.customerDocument[0].idCardVerso != null && resultFutureOwner.data.customerDocument[0].idCardVerso.id){
                this.futureOwnerDocuments[1].id = resultFutureOwner.data.customerDocument[0].idCardVerso.id
                this.futureOwnerDocuments[1].valid = resultFutureOwner.data.customerDocument[0].idCardVerso.valid
            }
            if(resultFutureOwner.data.customerDocument[0].procuration != null && resultFutureOwner.data.customerDocument[0].procuration.id){
                this.futureOwnerDocuments[2].id = resultFutureOwner.data.customerDocument[0].procuration.id
                this.futureOwnerDocuments[2].valid = resultFutureOwner.data.customerDocument[0].procuration.valid
            }
          }

          this.initLoading = false

        } catch (e) {
          this.initLoading = false
          this.showBanner('danger', 'Une erreur est survenue lors de la récupération des documents.')
        }
      },

      setUploadLoading (type) {
        this.uploadLoading = type
      }
    },

    apollo: {
      ownerInformation: {
        query () {
          if (this.isCurrentOwner) {
            return this.$parent.ownerInformationQuery
          } else {
            return this.$parent.futureOwnerInformationsQuery
          }
        },
        update (data) {
          if (this.isCurrentOwner) {
            return data.ownerInformation
          } else {
            return data.futureOwner
          }
        },
      },
    }
  }
</script>
